<template>
  <div id="app">
    <card
      class="stripe-card"
      ref="card"
      :class="{ complete }"
      :stripe="stripeToken"
      :options="stripeOptions"
      @change="onChange($event)"
      :key="stripeKey" />
    <div id="card-errors" role="alert" class="text-light" v-text="errorMessage"></div>
  </div>
</template>

<script>
import { Card } from "vue-stripe-elements-plus";

export default {
  props: ["defaultcc"],
  name: "stripe-component",
  data() {
    return {
      complete: false,
      check: false,
      errorMessage: "",
      mountStripeElement: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
        style: {
          base: {
            // color: 'white',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            // '::placeholder': {
            //     color: 'white'
            // }
          },
          // invalid: {
          //     color: 'white',
          //     iconColor: 'white'
          // }
        },
        hidePostalCode: true,
        value: {
          card_number: 4242424242424242,
        },
      },
      stripeKey: 1,
    };
  },
  computed: {
    stripeToken: function () {
      return process.env.MIX_STRIPE_TOKEN;
    },
  },
  components: { Card },
  created() {
    if (this.$store.state.theme == "dark") {
      this.stripeOptions.style = {
        base: {
          color: "white",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "white",
          },
        },
      };
      this.$forceUpdate();
    }
  },
  watch: {
    defaultcc: function (val) {
      if (val) {
        if (val.substring(0, 4) == "card") {
          this.check = true;
          this.$refs.card.clear();
        }
      }
    },
  },
  methods: {
    onChange(event) {
      this.errorMessage = event.error ? event.error.message : "";
      if (this.check == false) {
        this.$emit("update", "");
      }
      this.check = false;
    },
  },
};
</script>
